var TYPE = "UI_STATE";
export var isUiStateMessage = function isUiStateMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};

/**
 * An event message used for retrieving current UI state
 */
export var uiStateMessage = function uiStateMessage(payload) {
  return {
    type: TYPE,
    payload: payload
  };
};